module.exports = __webpack_public_path__ + "static/media/key.266b30aa.svg";